import AuthCli from './AuthCli'

/**
 * JavaScript version of the Outbox service API.
 */
export default class ProductCli {

  //
  // Path constants:
  //
  static get SERVICE_ROUTE() { return 'product' }
  static get PRODUCT_PATH() { return 'products' }
  static get CARRIER_PRODUCT_PATH() { return 'carrierproduct' }
  static get AVAILABLE_PATH() { return 'available' }
  static get PRICE_PATH() { return 'price' }
  static get NAMES_PATH() { return 'names' }
  static get PRICE_NAMES_OR_IDS_QUERY() { return 'pricenamesorids' }
  static get PRICE_ID_PATH() { return 'priceid' }
  static get BILLABLE_ID_QUERY() { return 'billableIdOrTitle' }
  static get PRODUCT_CODE_QUERY() { return 'productcode' }
  static get PRODUCT_CODE_PATH() { return 'productcode' }
  static get PRINT_COLOR_QUERY() { return 'printcolor' }
  static get PRINT_DUPLEX_QUERY() { return 'printduplex' }
  static get PAGES_QUERY() { return 'pages' }
  static get INCLUDE_VAT_QUERY() { return 'includevat' }
  static get MAPPING_PATH() { return 'mapping' }
  static get DESTINATION_COUNTRY_ISO_QUERY() { return 'destinationcountryiso' }
  static get DESTINATION_POSTAL_CODE_QUERY() { return 'destinationpostalcode' }
  static get SIDI_PRODUCT_CODE() { return ["CX", "RV", "CU", "NV"]; }

  // URL prefix for debugging environment vs behind reverse proxy environment.
  static get devPrefix() { return (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 'http://localhost:6007/' : window.location.protocol + '//' + window.location.host + '/api/' }

 /**
   * Provides the list of all products available in the system.
  */
  static async GetProduct(productCode) {
    var verb = 'GET'
    var path = this.SERVICE_ROUTE + '/' + productCode
    var body = null

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }

  /**
   * Provides the list of all products available in the system.
  */
  static async GetAllProducts() {
    var verb = 'GET'
    var path = this.SERVICE_ROUTE + '/' + this.PRODUCT_PATH
    var body = null

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }

  /**
   * Provides the list of all carrier products available in the system.
  */
  static async GetAllCarrierProducts() {
    var verb = 'GET'
    var path = this.SERVICE_ROUTE + '/' + this.CARRIER_PRODUCT_PATH
    var body = null

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }

  /**
   * Provides the list of the products the calling user is allowed to select
   * for sending shipments.
  */
  static async GetAvailableProductsForUser() {
    var verb = 'GET'
    var path = this.SERVICE_ROUTE + '/' + this.PRODUCT_PATH + '/' + this.AVAILABLE_PATH
    var body = null

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }

  /**
   * Provides the external identifiers of all price lists
  */
  static async GetAllPriceNames() {
    var verb = 'GET'
    var path = this.SERVICE_ROUTE + '/' + this.PRICE_PATH + '/' + this.NAMES_PATH
    var body = null

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }

  /**
   * Provides the details of some price lists.
   * @param {string[]} priceNamesOrIds External or internal identifiers of price lists asking for
   * @returns 
   */
  static async GetPrices(priceNamesOrIds) {
    var verb = 'GET'
    var path = this.SERVICE_ROUTE + '/' + this.PRICE_PATH + '?' + this.PRICE_NAMES_OR_IDS_QUERY + '=' + JSON.stringify(priceNamesOrIds)
    var body = null

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }

  /**
  * Creates or modifies a price list.
  * @param {PriceInfo} price Details of the price list to store. Pass null ID for a new price list otherwise considered the update of an existing one
  * @returns Internal identifier of the price list stored
  */
  static async StorePrice(price) {
    var verb = 'PUT'
    var path = this.SERVICE_ROUTE + '/' + this.PRICE_PATH
    var body = price

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }


  /**
  * Removes a price list from the system.
  * @param {string} price Internal identifier of the price list to remove
  * @returns 
  */
  static async RemovePrice(priceId) {
    var verb = 'DELETE'
    var path = this.SERVICE_ROUTE + '/' + this.PRICE_PATH + '/' + priceId
    var body = null

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }


  /**
   * Indicates what is the current price of a shipment given its features.
   * The price is calculated considering the price list currently assigned to the billable,
   * also considered the current mapping between product code and carrier product.
   * @param {string} billableId Internal identifier of the billable this shipment is for
   * @param {string} productCode External unique identifier of a product, e.g. "BCC"
   * @param {string} destinationCountryIso Country code of the shipment's destination
   * @param {string} destinationPostalCode Postal code of the shipment's destination
   * @param {bool} printColor Whether the shipment's document will be printed in color ink, otherwise in black and white
   * @param {bool} printDuplex Whether the shipment's document will be printed duplex, i.e. both sides of the sheet, otherwise simplex
   * @param {int} pages Total number of pages the shipment's document contains
   * @param {bool} includeVat Whether to provide the price including the applicable VAT percentage
   * @returns Calculated price in cents
   */
  static async CalculatePriceOfShipment(billableId, productCode, destinationCountryIso, destinationPostalCode, printColor, printDuplex, pages, includeVat) {
    var verb = 'GET'
    var path = this.SERVICE_ROUTE + '/' + this.PRODUCT_PATH + '/' + this.PRICE_PATH + '?'
      + this.BILLABLE_ID_QUERY + '=' + billableId + '&'
      + this.PRODUCT_CODE_QUERY + '=' + productCode + '&'
      + this.DESTINATION_COUNTRY_ISO_QUERY + '=' + destinationCountryIso + '&'
      + this.DESTINATION_POSTAL_CODE_QUERY + '=' + destinationPostalCode + '&'
      + this.PRINT_COLOR_QUERY + '=' + printColor + '&'
      + this.PRINT_DUPLEX_QUERY + '=' + printDuplex + '&'
      + this.PAGES_QUERY + '=' + pages + '&'
      + this.INCLUDE_VAT_QUERY + '=' + includeVat
    var body = null

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }

  /**
  * assign mapping to product
  * @param {ProductMapping} mapping Details of the mapping product to store. 
  * @returns Internal identifier of the price list stored
  */
  static async AssignMapping(mapping) {
    var verb = 'PUT'
    var path = this.SERVICE_ROUTE + '/' + this.MAPPING_PATH
    var body = mapping

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }

}


// WEBPACK FOOTER //
// ./src/sdk/ProductCli.js